import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_market/relations/")({
	beforeLoad: () => {
		throw redirect({ to: "/relations/buyer", replace: true });
	},
});
